// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dancing-dots":"dancing-dots___3h4dg","dancing-dots-jump":"dancing-dots-jump___3H6PF","one":"one___4EqUO","two":"two___37W15","three":"three___KWH5e"};